import Deliverables from './container';

export default Deliverables;



// WEBPACK FOOTER //
// ./src/components/Steps/Deliverables/index.js